<template>
  <div>
    <!-- GMB未連携 -->
    <template v-if="gmbNoLinked">
      <div>
        <h2 class="c-pageTitle">
          {{ $t('components.RequireGmbConnect.title') }}
        </h2>
        <p>{{ $t('pages.CompaniesLocationStore.service.requireGmbConnect.notice') }}</p>
        <div class="c-button c-button--left">
          <a
            :href="`/s/companies/${companyUuid}/google_oauth`"
            class="c-button__item c-button__item--primary"
          >
            {{ $t('pages.CompaniesLocationStore.service.requireGmbConnect.doConnect') }}
          </a>
        </div>
      </div>
    </template>
    <!-- カテゴリがない場合 -->
    <template v-else-if="!categories.length">
      <div class="p-box__body">
        <p>{{ $t('pages.CompaniesLocationStore.service.noCategories.content1') }}</p>
        <p>{{ $t('pages.CompaniesLocationStore.service.noCategories.content2') }}</p>
      </div>
    </template>
    <template v-else>
      <Info v-if="showOnlyOwnerAuthority">
        {{ $t('pages.CompaniesLocationStore.service.info') }}
        <router-link :to="{ name: 'CompaniesServices', params: { company_uuid: companyUuid }}">
          {{ $t('pages.CompaniesLocationStore.service.link') }}
        </router-link>
      </Info>
      <div v-for="(category, categoryIndex) in categories" :key="`category-${categoryIndex}`" class="category">
        <ServicePattern
          :category="category"
          :store-service-pattern="selectedServicePattern(category)"
          :show-only-owner-authority="showOnlyOwnerAuthority"
          @update-store-service-pattern="handleUpdateStoreServicePattern"
        />
      </div>
    </template>
  </div>
</template>

<script>

import ServicePattern from './Service/ServicePattern'
import Info from '../Info'

export default {
  name: 'CompaniesLocationStoreService',
  components: {
    Info,
    ServicePattern,
  },
  props: {
    categories: {
      type: Array,
      default: () => []
    },
    storeServicePatterns: {
      type: Array,
      default: () => []
    },
    showOnlyOwnerAuthority: {
      type: Boolean,
      required: true,
    },
    gmbNoLinked: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['update-store-service-pattern'],
  computed: {
    companyUuid() { return this.$route.params.company_uuid }
  },
  methods: {
    selectedServicePattern(category) {
      return this.storeServicePatterns.find(s => s.gmbCategoryId === category.gmbCategoryId)
    },
    handleUpdateStoreServicePattern(servicePatternId) {
      this.$emit('update-store-service-pattern', servicePatternId)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../stylesheets/biz_spa/foundation/_var.scss';

.category {
  padding-bottom: 48px;
  &:last-child {
    padding-bottom: 24px;
  }
}

</style>
